let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lxkzL"), load("aQdv9"), load("hhss7"), load("6XyGC")]).then(() => parcelRequire('cV69w'));